import React from "react";
import Modal from "./Components/Modal";

// Icons
import { X } from 'lucide-react';

interface props {
  show: boolean;
  onHide: () => void;
  onDelete: () => void;
  title?: string;
  content?: string;
  cancelText?: string;
  deleteText?: string;
}

const DeleteModal: React.FC<props> = ({ show, onHide, onDelete, title, content, cancelText, deleteText }) => {
  return (
    <React.Fragment>
      <Modal
        show={show}
        onHide={onHide}
        id="deleteModal"
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName='w-[calc(100vw-2rem)] max-w-[25rem] mx-4  bg-white shadow rounded-md dark:bg-zink-600'>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] overflow-y-auto px-4 py-2">
          <div className="float-right">
            <button data-modal-close="deleteModal" className="transition-all duration-200 ease-linear text-slate-500 hover:text-red-500"><X className="size-5" onClick={onHide} /></button>
          </div>
          <div className="mt-5 text-center">
            <p className="text-start font-bold text-[14px] md:text-[15px] mb-6">{title}</p>
            <p className="text-start">{content}</p>
            <div className="flex justify-end gap-2 mt-10">

              <button type="reset" className="bg-white text-slate-500 btn hover:text-slate-500 hover:bg-slate-100 focus:text-slate-500 focus:bg-slate-100 active:text-slate-500 active:bg-slate-100 dark:bg-zink-600 dark:hover:bg-slate-500/10 dark:focus:bg-slate-500/10 dark:active:bg-slate-500/10" onClick={onHide}>{!!cancelText ? cancelText : 'Cancel'}</button>
              <button type="submit" id="deleteRecord" data-modal-close="deleteModal" className="text-white bg-custom-500 border-custom-500 btn hover:text-white hover:custom-500 hover:border-custom-600 focus:text-white focus:bg-custom-500 focus:border-custom-500 focus:ring focus:ring-red-100 active:text-white active:bg-custom-500 active:border-custom-500 active:ring active:ring-red-100 dark:ring-custom-400/20" onClick={onDelete}>{!!deleteText ? deleteText : 'Yes, Proceed'}</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default DeleteModal;